module.exports = Rx;


//////////////////
// WEBPACK FOOTER
// external "Rx"
// module id = 5
// module chunks = 0